import Price from "./Price";
import ReportSalary from "./ReportSalary";
import ReportSalaryDetails from "./ReportSalaryDetails";
import ReportDaily from "./ReportDaily";
import ReportSchedule from "./ReportSchedule";
import ReportClients from "./ReportClients";

const obj = {
    price: Price,
    reportSalary: ReportSalary,
    reportSalaryDetails: ReportSalaryDetails,
    reportDaily: ReportDaily,
    reportSchedule: ReportSchedule,
    reportClients: ReportClients,
};

export default obj;
